import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaPlus, FaSearch, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import API_BASE_URL from '../../../../config/api';
import '../Nucleos/Nucleos.css';

const Profissoes = () => {
  const [profissoes, setProfissoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    profissao: '',
    ativo: true
  });
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadProfissoes();
  }, []);

  const loadProfissoes = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/profissoes`);
      if (!response.ok) {
        throw new Error('Erro ao buscar profissões');
      }
      const data = await response.json();
      
      const formatadas = data.map(item => ({
        id: item.id_profissao,
        profissao: item.nome_profissao,
        ativo: item.ativo
      }));
      
      setProfissoes(formatadas);
      setLoading(false);
    } catch (error) {
      console.error('Erro ao carregar profissões:', error);
      setLoading(false);
    }
  };

  const handleNew = () => {
    setFormData({
      id: '',
      profissao: '',
      ativo: true
    });
    setIsEditing(false);
    setShowForm(true);
  };

  const handleEdit = (profissao) => {
    setFormData({
      id: profissao.id,
      profissao: profissao.profissao,
      ativo: profissao.ativo
    });
    setIsEditing(true);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta profissão?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/profissoes/${id}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          throw new Error('Erro ao excluir profissão');
        }
        
        loadProfissoes();
      } catch (error) {
        console.error('Erro ao excluir profissão:', error);
        alert('Erro ao excluir profissão');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const url = isEditing 
        ? `${API_BASE_URL}/profissoes/${formData.id}`
        : `${API_BASE_URL}/profissoes`;
      
      const method = isEditing ? 'PUT' : 'POST';
      
      const payload = {
        nome_profissao: formData.profissao,
        ativo: formData.ativo
      };

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Erro ao salvar profissão');
      }

      setShowForm(false);
      loadProfissoes();
    } catch (error) {
      console.error('Erro ao salvar profissão:', error);
      alert('Erro ao salvar profissão');
    } finally {
      setSaving(false);
    }
  };

  const filteredProfissoes = profissoes.filter(p =>
    p && p.profissao && p.profissao.toLowerCase().includes((searchTerm || '').toLowerCase())
  );

  return (
    <div className="nucleos-container">
      {!showForm ? (
        <>
          <div className="tabela-header">
            <div className="header-content">
              <h1>Profissões</h1>
            </div>
            <button className="btn-primary" onClick={handleNew}>
              <FaPlus /> Nova Profissão
            </button>
          </div>

          <div className="table-container">
            <div className="table-controls">
              <div className="search-container">
                <FaSearch />
                <input
                  type="text"
                  placeholder="Buscar profissão..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="table-info">
                {filteredProfissoes.length} registros encontrados
              </div>
            </div>

            <div className="table-wrapper">
              <table className="data-table nucleos-table">
                <thead>
                  <tr>
                    <th className="col-id">ID</th>
                    <th className="col-nome">Profissão</th>
                    <th className="col-status">Status</th>
                    <th className="col-acoes">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                        Carregando...
                      </td>
                    </tr>
                  ) : filteredProfissoes.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                        Nenhum registro encontrado
                      </td>
                    </tr>
                  ) : (
                    filteredProfissoes.map((profissao) => (
                      <tr key={profissao.id}>
                        <td>{profissao.id}</td>
                        <td>{profissao.profissao}</td>
                        <td>
                          <span className={`status-badge ${profissao.ativo ? 'ativo' : 'inativo'}`}>
                            {profissao.ativo ? 'Ativo' : 'Inativo'}
                          </span>
                        </td>
                        <td className="col-acoes">
                          <div className="action-buttons">
                            <button 
                              className="btn-edit"
                              onClick={() => handleEdit(profissao)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                            <button 
                              className="btn-delete"
                              onClick={() => handleDelete(profissao.id)}
                              title="Excluir"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{isEditing ? 'Editar Profissão' : 'Nova Profissão'}</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-content">
              <div className="form-group">
                <label htmlFor="profissao">Profissão *</label>
                <input
                  type="text"
                  id="profissao"
                  className="form-control"
                  value={formData.profissao}
                  onChange={(e) => setFormData({...formData, profissao: e.target.value})}
                  required
                  maxLength={50}
                />
              </div>

              <div className="form-group">
                <Toggle
                  id="ativo"
                  label="Status:"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Profissoes;
